export default "__VITE_ASSET__67421b94__"